import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
// Import story data
import theMissingHourData from '../story/the-missing-hour/characters_data.json';

// Story configuration
const AVAILABLE_STORIES = {
  'the-missing-hour': {
    id: 'the-missing-hour',
    title: 'The Missing Hour',
    description: 'Laura Palmer murder investigation in Twin Peaks',
    data: theMissingHourData,
    imagePath: './story/the-missing-hour/images/'
  }
  // Future stories can be added here
};

function Login() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedStory, setSelectedStory] = useState('the-missing-hour');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Store selected story in sessionStorage for app-wide access
    const storyInfo = AVAILABLE_STORIES[selectedStory];
    
    // Store selected story in sessionStorage for app-wide access
    sessionStorage.setItem('selectedStory', selectedStory);
    
    setIsLoggedIn(true);
  };

  if (isLoggedIn) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Silent Witness</h1>
          <p>Digital Investigation Platform</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">USERNAME</label>
            <input 
              type="text" 
              id="username" 
              className="login-input"
              placeholder="Enter your username..."
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">PASSWORD</label>
            <input 
              type="password" 
              id="password" 
              className="login-input"
              placeholder="Enter your password..."
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="story">CASE FILE</label>
            <select 
              id="story"
              className="login-select"
              value={selectedStory}
              onChange={(e) => setSelectedStory(e.target.value)}
            >
              {Object.values(AVAILABLE_STORIES).map(story => (
                <option key={story.id} value={story.id}>
                  {story.title} - {story.description}
                </option>
              ))}
            </select>
          </div>
          
          <button type="submit" className="login-button">
            SUBMIT
          </button>
        </form>
        
        <div className="login-footer">
          <p>Classified Access Required</p>
          <p>Authorized Personnel Only</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
